/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Checklist.
 * @export
 */
export const ICON_CHECKLIST = (
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.4287 9.95313C25.4287 9.31146 24.9037 8.78646 24.2621 8.78646H16.0954C15.4537 8.78646 14.9287 9.31146 14.9287 9.95313C14.9287 10.5948 15.4537 11.1198 16.0954 11.1198H24.2621C24.9037 11.1198 25.4287 10.5948 25.4287 9.95313ZM14.9287 19.2865C14.9287 19.9281 15.4537 20.4531 16.0954 20.4531H24.2621C24.9037 20.4531 25.4287 19.9281 25.4287 19.2865C25.4287 18.6448 24.9037 18.1198 24.2621 18.1198H16.0954C15.4537 18.1198 14.9287 18.6448 14.9287 19.2865ZM11.9771 6.02146C12.4321 6.47646 12.4321 7.21146 11.9771 7.66646L7.04205 12.6248C6.58705 13.0798 5.85205 13.0798 5.38538 12.6248L2.91205 10.1398C2.45705 9.6848 2.45705 8.9498 2.91205 8.4948C3.36705 8.0398 4.10205 8.0398 4.55705 8.4948L6.21372 10.1515L10.3437 6.02146C10.7871 5.57813 11.5337 5.57813 11.9771 6.02146ZM11.9887 15.3665C12.4437 15.8215 12.4437 16.5565 11.9887 17.0115L7.05372 21.9698C6.59872 22.4248 5.86372 22.4248 5.39705 21.9698L2.91205 19.4731C2.45705 19.0181 2.45705 18.2831 2.91205 17.8281C3.36705 17.3731 4.10205 17.3731 4.55705 17.8281L6.21372 19.4848L10.3437 15.3548C10.7871 14.9115 11.5337 14.9115 11.9887 15.3665Z"
      fill="#707070"
    />
  </svg>
);
